<template>
    <div class="lg:w-1/2 m-auto">
        <setup-substep name="vip-substep-1" next-text="Ok, done" next-substep="vip-substep-2" open>
            <p class="my-2 font-bold">🌟 VIP Keywords make sure you don't miss out urgent transactional emails.</p>

            <p class="my-2">We've added some VIP keywords to make sure you do not miss out on emails like password resets/email confirmations. Feel free to add more or remove any of them. You can always change them later.</p>

            <div class="mt-6 ">
                <p class="text-gray-darker text-sm">Emails containing any of these words will be immediately delivered.</p>
                <tag-input
                    class="bg-gray-light"
                    placeholder="Add keywords..."
                    :current="whitelists.keywords"
                    @change="newKeywords => whitelists.keywords = newKeywords"
                />
            </div>
        </setup-substep>

        <setup-substep name="vip-substep-2" next-text="Ok, done" next-substep="vip-substep-3">
            <span class="border-t my-4 border-gray-dark block"></span>

            <p class="my-2 font-bold">Next, VIP domains.</p>

            <p class="my-2">Do you use any important services or work with VIP clients whose domains you want to consider urgent? You can always change them later.</p>

            <div class="mt-6 ">
                <p class="text-gray-darker text-sm">Emails from any of these domains will be immediately delivered.</p>
                <tag-input
                    class="bg-gray-light"
                    placeholder="Add domains..."
                    :current="whitelists.domains"
                    @change="newKeywords => whitelists.domains = newKeywords"
                />
            </div>
            <div class="mt-4 w-full">
                <p class="text-destructive" v-if="errors.domains">{{ errors.domains }}</p>
            </div>
        </setup-substep>

        <setup-substep name="vip-substep-3" next-text="Activate Mailman →" @completed="done">
            <span class="border-t my-4 border-gray-dark block"></span>

            <p class="mt-4 mb-2"><strong>VIPs are set!</strong> Now, it's time to activate Mailman.</p>
        </setup-substep>
    </div>
</template>

<script>
export default {
    id   : 'vips',
    icon : 'star',
    label: 'VIPs',

    data() {
        return {
            errors: {
                domains: undefined,
            },
            whitelists  : {
                domains  : [],
                addresses: [],
                keywords : [],
            },
        }
    },

    mounted() {
        axios.get(`/api/mailbox`)
            .then((response) => {
                this.whitelists.keywords  = response.data.data.whitelists.keywords;
                this.whitelists.domains   = response.data.data.whitelists.domains;
                this.whitelists.addresses = response.data.data.whitelists.addresses;
            })
            .catch(console.error);
    },

    methods: {
        done() {
            this.errors = {};
            axios.put(`/api/mailbox`, {
                whitelists: this.whitelists,
            })
            .then(() => {
                this.$emit('done');
            })
            .catch((err) => {
                if(err.response.status === 422) {
                    this.handleErrors(err.response.data);
                } else {
                    console.error(err);
                }
            });
        },
        handleErrors(response) {
            this.errors.domains = _.first(response.errors['whitelists.domains']) ||  '';
            if(Object.keys(response.errors).some(function(k){ return ~k.indexOf("whitelists.domains.") })){
                // it has invalid addresses
                this.errors.domains = 'One or more of these are not valid domains.'
            }
        },
    }
}
</script>
